import { create } from 'zustand';
import type { ChildId } from '~/api/aspida/@types';

interface FirstLoginState {
  firstLoginChildIds: Set<ChildId>;
  setFirstLogin: (childId: ChildId, isFirstLogin: boolean) => void;
}

export const useIsFirstLogin = (childId: ChildId | undefined): boolean => {
  const firstLoginChildIds = useFirstLoginStore((s) => s.firstLoginChildIds);
  return childId ? firstLoginChildIds.has(childId) : false;
};

export const useFirstLoginStore = create<FirstLoginState>((set) => ({
  firstLoginChildIds: new Set(),
  setFirstLogin: (childId, isFirstLogin) =>
    set((state) => {
      const next = new Set(state.firstLoginChildIds);
      if (isFirstLogin) {
        next.add(childId);
      } else {
        next.delete(childId);
      }
      return { firstLoginChildIds: next };
    }),
}));
